import "./App.css";
import "./Assets/css/MobMainCss.css";
import { BrowserRouter as Router } from "react-router-dom";
import LanguageRoutes from "./LanguageRoutes";

function App() {
  return (
    <Router>
      <div id="root">
        <div className="app-container">
          <LanguageRoutes />
        </div>
      </div>
    </Router>
  );
}

export default App;
